import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { HashLoader } from "react-spinners";
import styles from "./About.module.css";
import "animate.css";
// data fetch
import { getAbout, getResume } from "../../Firebase/FirebaseFetch";
function About(props) {
  const [isLoading, setIsloading] = useState(true);
  const [about, setAbout] = useState("");
  const [resume, setResume] = useState("");
  const getData = async () => {
    setIsloading(true);
    await getAbout().then((res) => {
      setAbout(res);
    });
    setIsloading(false);
  };
  const getResumeData = async () => {
    setIsloading(true);
    await getResume().then((res) => {
      setResume(res);
    });
    setIsloading(false);
  };
  useEffect(() => {
    getResumeData();
    getData();
  }, []);
  const handleResume = () => {
    const link = document.createElement("a");
    link.href = resume;
    link.target = "_blank";
    link.click();
  };
  return (
    <Container id="about" className={`${styles.about}`}>
      <Row>
        <Col className="">
          {isLoading ? (
            <div className={styles.loader}>
              <HashLoader color="#ffffff" />
            </div>
          ) : (
            <div>
              <div className="d-flex justify-content-between">
                <h3
                  className={`${styles.heading} text-center text-md-start animate__animated animate__fadeInLeft `}
                >
                  About{" "}
                  <span
                    className={`${styles.important} animate__animated animate__fadeInRight`}
                  >
                    Me
                  </span>
                </h3>
                <button className={styles.resume} onClick={handleResume}>
                  Resume
                </button>
              </div>
              <p
                className={`${styles.desc}  animate__animated animate__zoomIn`}
              >
                {about}
              </p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default About;
